import { render, staticRenderFns } from "./Instituciones.vue?vue&type=template&id=d748ba00&"
import script from "./Instituciones.vue?vue&type=script&lang=js&"
export * from "./Instituciones.vue?vue&type=script&lang=js&"
import style0 from "./Instituciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports